import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../../../../../components/ui/common/table";
import { cn } from "../../../../../lib/utils";
import { NO_RECORDS_LABEL } from "../../constants/facilityDrawer.constants";
import {
  FacilitySourceTableColumn,
  FacilitySourceTableRow
} from "../../types/facilityDrawer.types";

interface FacilityReadOnlyTableProps {
  columns: FacilitySourceTableColumn[];
  rows: FacilitySourceTableRow[];
}

const headerClassName = (index: number) =>
  cn("tw-font-semibold tw-text-primary", index >= 2 && "tw-text-right");

const cellClassName = (index: number) => {
  if (index === 0) return "tw-text-sm tw-text-foreground";
  if (index === 1) return "tw-text-sm tw-font-mono tw-text-foreground";
  return "tw-text-sm tw-font-mono tw-text-foreground tw-text-right";
};

const FacilityReadOnlyTable = ({ columns, rows }: FacilityReadOnlyTableProps) => (
  <div className="tw-overflow-x-auto">
    <Table>
      <TableHeader>
        <TableRow className="tw-bg-primary/5 hover:tw-bg-primary/5">
          {columns.map((column, index) => (
            <TableHead key={column.key} className={headerClassName(index)}>
              {column.header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.id}>
            {row.cells.map((cell, index) => (
              <TableCell key={`${row.id}-${index}`} className={cellClassName(index)}>
                {cell}
              </TableCell>
            ))}
          </TableRow>
        ))}
        {rows.length === 0 && (
          <TableRow>
            <TableCell
              colSpan={columns.length}
              className="tw-text-sm tw-text-muted-foreground tw-text-center tw-py-6"
            >
              {NO_RECORDS_LABEL}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </div>
);

export default FacilityReadOnlyTable;
